module.exports = __webpack_public_path__ + "img/photos/02.jpg";